<div class="tr md-no-proxy hover padding-10 layout-column"
     (click)="onSelectAccount(account)">

  <!--Account Details at the top-->
  <div class="flex small layout-row layout-align-start-center header-item">
    <app-account-avatar class="margin-right-10" [account]="account" [size]="'small'"></app-account-avatar>
    <app-demand-account-link class="flex" [account]="account" [isAllowCopyButton]="true"></app-demand-account-link>
    <span *ngIf="!account.active" class="blocked-badge margin-right-10 margin-right-5 text-ellipsis">BLOCKED</span>
  </div>

  <!-- Two-column container for the rest of the details -->
  <div class="layout-row layout-wrap">

    <!--External Id Row-->
    <div *ngIf="account.externalId"
         class="flex-50 layout-row layout-align-start-center column-item gap-5">
      <bringoz-icon iconName="hash"
                    classSize="lg"
                    fill="#424242">

      </bringoz-icon>
      <span class="br-body-2 font-weight-400">{{account.externalId}}</span>
    </div>

    <!--Account Type Row-->
    <div *ngIf="account.type"
         class="flex-50 layout-row layout-align-start-center column-item gap-5">
      <bringoz-icon iconName="status"
                    classSize="lg"
                    fill="#424242">

      </bringoz-icon>
      <span class="br-body-2 font-weight-400">{{account.type | translate}}</span>
    </div>

    <!--Shippers Row-->
    <div *ngIf="account.shippersIds?.length"
         class="flex-50 layout-row layout-align-start-center column-item gap-5">
      <bringoz-icon iconName="shipper"
                    classSize="lg"
                    fill="#424242">

      </bringoz-icon>
      <span class="br-body-2 font-weight-400">{{account.shippersIds.length}}</span>
    </div>

    <!--Phone Row-->
    <div *ngIf="account.phoneNumber"
         class="flex-50 layout-row layout-align-start-center column-item gap-5">
      <bringoz-icon iconName="shipper"
                    classSize="lg"
                    fill="#424242">

      </bringoz-icon>
      <span class="br-body-2 font-weight-400">{{account.phoneNumber | bringozPhone}}</span>
    </div>

    <!--Phone Row-->
    <div *ngIf="account.branchReferences?.length"
         class="flex-50 layout-row layout-align-start-center column-item gap-5">
      <bringoz-icon iconName="branch"
                    classSize="lg"
                    fill="#424242">

      </bringoz-icon>
      <branches-indicator [branches]="account.branchReferences"></branches-indicator>
    </div>

    <!--Phone Row-->
    <div *ngIf="account.additionalPhoneNumber"
         class="flex-50 layout-row layout-align-start-center column-item gap-5">
      <bringoz-icon iconName="phone"
                    classSize="lg"
                    fill="#424242">

      </bringoz-icon>
      <span class="br-body-2 font-weight-400">{{account.additionalPhoneNumber | bringozPhone}}</span>
    </div>

    <!--Business Category Row-->
    <div *ngIf="account.businessCategory"
         class="flex-50 layout-row layout-align-start-center column-item gap-5">
      <bringoz-icon iconName="status"
                    classSize="lg"
                    fill="#424242">

      </bringoz-icon>
      <span class="br-body-2 font-weight-400">{{account.businessCategory}}</span>
    </div>

    <!--Created At Row-->
    <div *ngIf="account.createdAt"
         class="flex-50 layout-row layout-align-start-center column-item gap-5">
      <bringoz-icon iconName="timer-outline"
                    classSize="lg"
                    fill="#424242">

      </bringoz-icon>
      <span class="br-body-2 font-weight-400">{{account | bringozFullDate: 'createdAt'}}</span>
    </div>

    <!--Updated At Row-->
    <div *ngIf="account.updatedAt"
         class="flex-50 layout-row layout-align-start-center column-item gap-5">
      <bringoz-icon iconName="timer-outline"
                    classSize="lg"
                    fill="#424242">

      </bringoz-icon>
      <span class="br-body-2 font-weight-400">{{account | bringozFullDate: 'updatedAt'}}</span>
    </div>

  </div>

</div>
